import { TaskCancelRequest, TaskForm } from '@dispatch/shared/types';

export const formDefaults: Partial<TaskForm> = {
  claim: {
    lossLocation: {
      streetLine1: '',
      streetLine2: '',
      city: '',
      state: '',
      zip: '',
    },
    jobId: '',
    taskId: '',
    claimNumber: '',
    insuredName: '',
    catCode: '',
    propertyType: '',
    dateOfLoss: '',
    dateOfNotice: '',
    peril: '',
    sourcedFrom: '',
    isModularHome: false,
    jobNumber: '',
    timeZone: '',
  },
  contact: {
    primary: {
      lastName: '',
      firstName: '',
      phone: '',
      email: '',
      contactMethod: '',
      phone2: '',
      notes: '',
    },
    secondary: {
      lastName: '',
      firstName: '',
      phone: '',
      email: '',
      contactMethod: '',
      phone2: '',
      notes: '',
    },
    altLocation: {
      streetLine1: '',
      streetLine2: '',
      city: '',
      state: '',
      zip: '',
    },
  },
  assignmentHandling: {
    travel: true,
    isStateLicenseRequired: true,
    templateId: '',
    durationInMinutes: 0,
    priority: '',
    appointment: '',
    severity: '',
    methodOfInspection: '',
    overridePriority: false,
    notes: '',
    preferredLanguage: '',
  },
  attributes: [],
  needsReason: false,
  reasonCode: '',
};

export const formCancelDefaults: TaskCancelRequest = {
  cancelReason: '',
};
